import arrowNext from "assets/icons/Arrow Next.svg";
import arrowPrev from "assets/icons/Arrow Prev.svg";
import downIcon from "assets/icons/downl.svg";
import moment from "jalali-moment";
import React, { useEffect, useState } from "react";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Archives from "services/apis/archivesAPI";
import rialConvertToToman from "utils/convertRialToToman/convertRialToToman";
import { logger } from "utils/logger/logger";
import PriceSeparator from "utils/priceSeparator/PriceSeparator";
import statusHandler from "utils/processStatusHandler/processStatusHandler";
import PageCounter from "components/pageCounter/PageCounter";
import "./index.css";
import {
  DownloadWrapper,
  DropDownContainer,
  OptionContainer,
  Paginate,
  TableContainer,
  TableHeader,
  TableRowCard,
  Tbody,
} from "./index.styled";
import { LuTrash2 } from "react-icons/lu";
import { LuDownload } from "react-icons/lu";
import RemoveItemModal from "../../removeItemModal";

const TableSection = ({ socketStatus }) => {
  logger.log()("<TableSection/> socketStatus : ", socketStatus);
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage, setDataPerPage] = useState(5);
  const [tabelData, setTableData] = useState(null);
  const [numberOfPages2, setNumberOfPages2] = useState(0);

  async function getTableData(filters, page=0) {
    const params = {
      count: dataPerPage,
      page: page ? page : currentPage,
      [filters.key]: filters.filter,
    };

    const response = await new Archives().getArchives(params);

    const rows = response.data.data.rows;

    rows.map((item) => {
      const status = statusHandler(item.status);
      item.status_lable = status;
    });

    setTableData(response.data.data);

    let tempNumberOfPages = [...arrOfCurrButtons];

    let dotsInitial = "...";
    let dotsLeft = "... ";
    let dotsRight = " ...";

    const numberOfPages = [
      ...Array(Math.ceil(response.data.data.count / dataPerPage) + 1).keys(),
    ].slice(1);

    setNumberOfPages2(numberOfPages);

    if (numberOfPages.length < 6) {
      tempNumberOfPages = numberOfPages;
    } else if (currentPage >= 1 && currentPage <= 3) {
      tempNumberOfPages = [1, 2, 3, 4, dotsInitial, numberOfPages.length];
    } else if (currentPage === 4) {
      const sliced = numberOfPages.slice(0, 5);
      tempNumberOfPages = [...sliced, dotsInitial, numberOfPages.length];
    } else if (currentPage > 4 && currentPage < numberOfPages.length - 2) {
      // from 5 to 8 -> (10 - 2)
      const sliced1 = numberOfPages.slice(currentPage - 2, currentPage); // sliced1 (5-2, 5) -> [4,5]
      const sliced2 = numberOfPages.slice(currentPage, currentPage + 1); // sliced1 (5, 5+1) -> [6]
      tempNumberOfPages = [
        1,
        dotsLeft,
        ...sliced1,
        ...sliced2,
        dotsRight,
        numberOfPages.length,
      ]; // [1, '...', 4, 5, 6, '...', 10]
    } else if (currentPage > numberOfPages.length - 3) {
      // > 7
      const sliced = numberOfPages.slice(numberOfPages.length - 4); // slice(10-4)
      tempNumberOfPages = [1, dotsLeft, ...sliced];
    } else if (currentPage === dotsInitial) {
      // [1, 2, 3, 4, "...", 10].length = 6 - 3  = 3
      // arrOfCurrButtons[3] = 4 + 1 = 5
      // or
      // [1, 2, 3, 4, 5, "...", 10].length = 7 - 3 = 4
      // [1, 2, 3, 4, 5, "...", 10][4] = 5 + 1 = 6
      setCurrentPage(arrOfCurrButtons[arrOfCurrButtons.length - 3] + 1);
    } else if (currentPage === dotsRight) {
      setCurrentPage(arrOfCurrButtons[3] + 2);
    } else if (currentPage === dotsLeft) {
      setCurrentPage(arrOfCurrButtons[3] - 2);
    }
    setArrOfCurrButtons(tempNumberOfPages);
    if (page) {
      setCurrentPage(page);
    } else {
      setCurrentPage(currentPage);
    }
  }

  useEffect(() => {
    if (tabelData && currentPage === 1) {
      const newn = [];
      tabelData?.rows?.map?.((item, index) => {
        const obj = { ...item };
        if (index === 0) {
          obj.status = socketStatus;
          const status = statusHandler(socketStatus);
          obj.status_lable = status;
        }
        newn.push(obj);
      });
      setTableData((prev) => ({ ...prev, rows: newn }));
    }
  }, [socketStatus]);
  useEffect(() => {
    if (!initialFilter) {
      getTableData({
        key: "createdAt",
        filter: "DESC",
      });
    } else {
      getTableData({
        key: initialFilter.key,
        filter: initialFilter.filter,
      });
    }
  }, [currentPage, dataPerPage, socketStatus]);

  const [arrOfCurrButtons, setArrOfCurrButtons] = useState([]);

  const rowLabels = [
    {
      sort: false,
      label: "ردیف",
      name: "row",
      data: [],
    },
    {
      sort: false,
      label: "نام فایل",
      name: "fileName",
      data: [],
    },
    {
      sort: true,
      label: "تعداد کاراکتر",
      name: "duration",
      data: [
        {
          label: "بیشترین",
          status: "DESC",
        },
        {
          label: "کمترین",
          status: "ASC",
        },
      ],
    },
    {
      sort: true,
      label: "هزینه (تومان)",
      name: "amount",
      data: [
        {
          label: "بیشترین",
          status: "ASC",
        },
        {
          label: "کمترین",
          status: "DESC",
        },
      ],
    },
    {
      sort: true,
      label: "وضعیت",
      name: "status",
      data: [
        {
          label: "آپلود",
          status: "upload",
        },
        {
          label: "در حال پردازش",
          status: "processing",
        },
        {
          label: "تکمیل شده",
          status: "success",
        },
        {
          label: "ناموفق",
          status: "failure",
        },
      ],
    },
    {
      sort: true,
      label: "زمان انجام",
      name: "createdAt",
      data: [
        {
          label: "قدیمی ترین",
          status: "ASC",
        },
        {
          label: "جدیدترین",
          status: "DESC",
        },
      ],
    },
    {
      sort: false,
      label: "عملیات",
      name: "operation",
      data: [],
    },
  ];
  const initialFiltersStatus = {
    duration: "ALL",
    amount: "ALL",
    createdAt: "ALL",
    status: "ALL",
  };
  const [filtersStatus, setFiltersStatus] = useState(initialFiltersStatus);
  const [initialFilter, setInitialFilter] = useState(null);

  function filterSubmit(keyIn, filter, dropDown) {
    const changedFiltersStatus = {
      duration: "ALL",
      amount: "ALL",
      createdAt: "ALL",
      status: "ALL",
    };
    if (!filter) {
      for (const [key, value] of Object.entries(filtersStatus)) {
        if (keyIn === key) {
          if (value === "ALL") {
            changedFiltersStatus[keyIn] = "ASC";
            getTableData({ key: keyIn, filter: "DESC" }, 1);
            setInitialFilter({
              key: keyIn,
              filter: "DESC",
            });
          } else if (value === "ASC") {
            changedFiltersStatus[keyIn] = "DESC";
            getTableData({ key: keyIn, filter: "ASC" }, 1);
            setInitialFilter({
              key: keyIn,
              filter: "ASC",
            });
          } else if (value === "DESC") {
            changedFiltersStatus[keyIn] = "ALL";
            getTableData({ key: "createdAt", filter: "DESC" }, 1);
            setInitialFilter({
              key: keyIn,
              filter: "DESC",
            });
          }
        }
      }
    } else {
      for (const [key, value] of Object.entries(filtersStatus)) {
        changedFiltersStatus[key] = "ALL";
      }
      changedFiltersStatus.status = "active";
      getTableData({ key: "status", filter }, 1);
      setInitialFilter({
        key: keyIn,
        filter,
      });
    }
    if (dropDown) {
      setShow(!show);
    }
    setFiltersStatus(changedFiltersStatus);
  }

  const [show, setShow] = useState(false);

  return (
    <>
      <TableContainer>
        <TableHeader>
          {rowLabels?.map?.((item, index) => {
            return (
              <div key={index}>
                {!item.sort && <span>{item.label}</span>}
                {item.sort && (
                  <>
                    {item.name === "status" && (
                      <DropDownContainer
                        className={
                          filtersStatus.status === "active" && "active"
                        }
                        onClick={(e) =>
                          filterSubmit(item.name, e.target.value, true)
                        }
                      >
                        <div>
                          <MdOutlineKeyboardArrowDown
                            className={show ? "open" : ""}
                          />
                          <span>{item.label ? item.label : "وضعیت"}</span>
                        </div>

                        <OptionContainer className={!show ? "hidden" : ""}>
                          {item?.data?.map?.((c) => {
                            return (
                              <option key={c.status} value={c.status}>
                                {c.label}
                              </option>
                            );
                          })}
                        </OptionContainer>
                      </DropDownContainer>
                    )}
                    {item.name !== "status" && (
                      <div
                        className="sort"
                        onClick={() => filterSubmit(item.name, null)}
                      >
                        <div className="pointers">
                          <span
                            className={
                              filtersStatus[item.name] === "ASC" && "active"
                            }
                          >
                            ⌃
                          </span>
                          <span
                            className={
                              filtersStatus[item.name] === "DESC" && "active"
                            }
                          >
                            ⌄
                          </span>
                        </div>
                        <span
                          className={
                            filtersStatus[item.name] !== "ALL" && "active"
                          }
                        >
                          {item.label}
                        </span>
                      </div>
                    )}
                  </>
                )}
              </div>
            );
          })}
        </TableHeader>
        <Tbody>
          <>
            {tabelData?.length === 0 && (
              <div className="mt-4 text-center font-semibold">
                دیتایی برای نمایش وجود ندارد
              </div>
            )}

            {tabelData &&
              tabelData?.rows?.map?.((row, index) => {
                const rowNumber =
                  currentPage !== 1
                    ? (currentPage - 1) * `${dataPerPage}` + index + 1
                    : index + 1;
                return <TableRow
                 row={row}
                  rowNumber={rowNumber}
                   key={index}
                    currentPage={currentPage}
                  callback = {()=>getTableData({
                    key: initialFilter?.key || "createdAt",
                    filter: initialFilter?.filter || "DESC",
                  }, tabelData.rows.length< 2 ? currentPage-1 : currentPage)}
              />;
              })}
          </>
        </Tbody>
        {tabelData && (
          <Paginate>
            <ul>
              <PageCounter
                active={numberOfPages2.length !== currentPage ? true : false}
                dataPerPageCounter={(num) => setDataPerPage(num)}
              />
              <li>
                <a
                  href="#"
                  className={`${currentPage === 1 ? "disabled" : ""}`}
                  onClick={() =>
                    setCurrentPage((prev) => (prev <= 1 ? prev : prev - 1))
                  }
                >
                  <img src={arrowPrev} alt="arrow prev" className="arrowPrev" />
                  قبلی
                </a>
              </li>
              {arrOfCurrButtons?.map?.((item, index) => {
                return (
                  <li key={index}>
                    <a
                      href="#"
                      className={`${currentPage === item ? "active" : ""}`}
                      onClick={() => setCurrentPage(item)}
                    >
                      {item}
                    </a>
                  </li>
                );
              })}
              <li>
                <a
                  href="#"
                  className={`${
                    currentPage === numberOfPages2.length ? "disabled" : ""
                  }`}
                  onClick={() =>
                    setCurrentPage((prev) =>
                      prev >= numberOfPages2.length ? prev : prev + 1
                    )
                  }
                >
                  بعدی
                  <img src={arrowNext} alt="arrow next" className="arrowNext" />
                </a>
              </li>
            </ul>
          </Paginate>
        )}
      </TableContainer>
    </>
  );
};

function TableRow({ row, rowNumber, currentPage, callback = ()=>{} }) {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const openModal = (e) => {
    e.stopPropagation();
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const removeItemHandler = async (id)=>{
    await new Archives()
    .removeItem(id)
    .then((r) => {
      const response = r.data;
      if(response.status==='success'){
        toast.success('عملیات با موفقیت انجام شد.');
        callback()
      }
      closeModal();
    })
    .catch((err) => {
      if (err?.response?.data?.data) {
        toast.warning(err?.response?.data?.data);
      }
    })
  }
  const formateDate = () => {
    const onlyDay =
      row.createdAt.substring(0, row.createdAt.lastIndexOf("T")) ||
      row.createdAt;
    const ready = onlyDay.replace(/[-]/g, "/");
    const mo = moment(ready, "YYYY/MM/DD").locale("fa").format("YYYY/MM/DD");
    return moment(ready, "YYYY/MM/DD").locale("fa").format("YYYY/MM/DD");
  };

  function removeExtension(filename) {
    return filename.substring(0, filename.lastIndexOf(".")) || filename;
  }

  function rowOnClick() {
    row.status === "success" &&
      navigate(`/convert-text-to-speech/edit/${row.id}`);
  }

  async function downloadOnClick(e) {
    e.stopPropagation();
    e.preventDefault();
    logger.log()("row...result...apiResult", row);

    if (!row.result.aiResult) {
      toast.info("لینک دانلود موجود نیست لطفا صفحه را مجددا بارگزاری نمایید ");
      return;
    }
    await new Archives()
      .getDownloadTextArchives(row.result.aiResult)
      .then((r) => {
        // const div = e.target;
        const a = document.createElement("a");
        const data = r.data;
        const file = new Blob([data], { type: "audio/mpeg" });
        a.href = window.URL.createObjectURL(file);
        a.download = `${row.title}.mp3`;

        // div.appendChild(a);

        a.click();

        a.remove();
      });
  }

  return (
    <TableRowCard
      onClick={rowOnClick}
      className={row.status !== "success" ? "table-row-card disable" : "table-row-card"}
      id={row.id}
    >
      <div className="row-overlay"></div>
      <div>{rowNumber}</div>
      <div>{removeExtension(`${row.title}`)}</div>
      {/* <div>{calculateSize(row.meta_data.size)}</div> */}
      <div>{row.meta_data.textCount}</div>
      <div>
        {PriceSeparator(
          rialConvertToToman(Math.abs(`${row.Transaction.amount}`))
        )}
      </div>
      <div>{row.status_lable}</div>
      <div>{formateDate()}</div>
      {/* TODO test this on disable mode  */}
      {
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {row.status === "success" ? (
            <button
              className="download"
              onClick={downloadOnClick}
              style={{
                backgroundColor: "transparent",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "5px",
                margin: "0 2px",
                border: "1px solid #0A5A3D",
                borderRadius: "5px",
                width: "30px",
                height: "30px",
                color: "#0A5A3D",
                cursor: "pointer",
              }}
            >
              <LuDownload />
            </button>
          ) : (
            <div
              className="download-deActive"
              style={{
                backgroundColor: "transparent",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "5px",
                margin: "0 2px",
                border: "1px solid #0A5A3D",
                borderRadius: "5px",
                width: "30px",
                height: "30px",
                color: "#0A5A3D",
              }}
            >
              <LuDownload />
            </div>
          )}
          <button
            className="trash"
            onClick={openModal}
            style={{
              backgroundColor: "transparent",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "5px",
              margin: "0 2px",
              border: "1px solid #ff3d3d",
              borderRadius: "5px",
              width: "30px",
              height: "30px",
              color: "#ff3d3d",
              cursor: "pointer",
            }}
          >
            <LuTrash2 />
          </button>
        </div>
      }
      <RemoveItemModal show={showModal} onClose={closeModal}>
        <h2 style={{ marginBottom: "20px", color: "#121212" }}>
          آیا از حذف این فایل اطمینان دارید؟
        </h2>
        <div>
          <button
            onClick={() => removeItemHandler(row.id)}
            className="accept-button-modal"
          >
            بله
          </button>
          <button onClick={closeModal} className="cancel-button-modal">
            خیر
          </button>
        </div>
      </RemoveItemModal>
    </TableRowCard>
  );
}

export default TableSection;
